module.exports = __webpack_public_path__ + "static/media/wordmark_white.c7fda10e.svg";